import { ActionDTO } from "./ActionDTO";
import { KeyDriverScoreDTO } from "./KeyDriverScoreDTO";
import { ResourcesDTO } from "./ResourcesDTO";
import { Serializable } from "./Serializable";

export class DashboardFirstPartDTO extends Serializable {

    strengths: KeyDriverScoreDTO[];
    opportunities: KeyDriverScoreDTO[];
    randomPhraseOne: string;
    randomPhraseTwo: string;
    actionOne: ActionDTO;
    resource: ResourcesDTO;

    constructor() {
        super();
    }
    
}